export const NOTE_PERMISSION_ERROR = 'You do not have permission to add notes.';

export const NOTE_SAVE_ERROR_MESSAGES = {
  permissionMessage: NOTE_PERMISSION_ERROR,
  fallbackMessage: 'Unable to save this note. Please try again.',
};
